import { createUuid } from '../util/createUuid';

export function partialFilePath(targetPath: string): string {
  return targetPath + '.part';
}

export function uniquePartialFilePath(targetPath: string): string {
  return `${targetPath}-${createUuid()}.part`;
}
